import Link from "next/link";
import { forwardRef } from "react";
import Parameter from "./Parameter";
import {
  Container,
  Heading,
  Icon,
  Subheading,
  Title,
  EcoLabel,
} from "./styles";
import Thumbnail from "./Thumbnail";

type Props = {
  slug: string;
  name: string;
  image: any;
  className?: string;
  subheading: string;
  param1: {
    label: string;
    value: string;
  };
  param2: {
    label: string;
    value: string;
  };
  eco: string;
};

const ProductCard = forwardRef<HTMLDivElement, Props>(function ProductCard(
  props,
  ref
) {
  const { className, slug, name, image, subheading, param1, param2, eco } =
    props;

  return (
    <Container ref={ref} className={className}>
      {!!eco && (
        <EcoLabel>
          <Icon /> <span>ecopositive</span>
        </EcoLabel>
      )}
      <Link href={"/products/" + slug} passHref>
        <Heading $isEco={!!eco}>
          <Title>{name}</Title>
        </Heading>
      </Link>
      <Subheading>{subheading}</Subheading>
      <Thumbnail image={image} />
      <Parameter {...param1} />
      <Parameter {...param2} />
    </Container>
  );
});

export default ProductCard;
